import {
  computed, Ref, ref,
} from 'vue';

export interface SavedData {
  userActiveDays: string[],
  lastPopupShowDate: string,
  feedbackAdded: boolean,
};

export const useLeaveFeedbackReminder = () => {
  const emptyData: SavedData = {
    userActiveDays: [],
    lastPopupShowDate: '',
    feedbackAdded: false,
  };

  const getSavedData = (): SavedData => {
    const data = localStorage.getItem('app-feedback-popup-data');

    if (data) {
      return {
        ...emptyData,
        ...JSON.parse(data),
      };
    }

    return emptyData;
  };

  const savedData: Ref<SavedData> = ref(getSavedData());

  const today = new Date().toISOString().split('T')[0];

  const isNewActiveDay = computed(() => !savedData.value.userActiveDays.includes(today));

  const isTimeToRemindFeedback = computed(() => {
    const activeDaysCount = savedData.value.userActiveDays.length;
    const isFirstTime = activeDaysCount === 4;
    const isRecurringTime = activeDaysCount > 4 && (activeDaysCount - 4) % 7 === 0;

    return !savedData.value.feedbackAdded && (isFirstTime || isRecurringTime);
  });

  const saveData = () => {
    localStorage.setItem('app-feedback-popup-data', JSON.stringify(savedData.value));
  };

  return {
    savedData,
    today,
    isNewActiveDay,
    isTimeToRemindFeedback,

    saveData,
  };
};
